<template>
  <a-modal title="师傅对账单" style="top: 20px" :width="1400" v-model="masterSingleible" footer="">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form2">
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="订单号" style="margin-left: 45px">
              <a-input v-model.trim="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
              <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in installTypes" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
              <a-select v-model="queryParam.orderType" @change="getorderStatus" :allowClear="true">
                <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单子状态" style="margin-left: 13px">
              <a-select v-model="queryParam.orderSubStatus" :allowClear="true">
                <a-select-option v-for="type in order_substate" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="客户姓名" style="margin-left: 30px">
              <a-input v-model.trim="queryParam.customerName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户联系方式">
              <a-input v-model.trim="queryParam.customerMobile" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-row :gutter="24" style="margin-left: 0px">
              <a-form-item label="客户地址" style="margin-left: 26px">
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                    <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">{{
                      type.provinceName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                    <a-select-option v-for="type in selectCityName" :key="type.cityCode">{{
                      type.cityName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.area" :allowClear="true">
                    <a-select-option v-for="type in selectAreaName" :key="type.areaCode">{{
                      type.areaName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="9" :sm="24">
                  <a-input v-model.trim="queryParam.address" />
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="品牌" style="margin-left: 60px">
              <a-select
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption"
                v-model="queryParam.brand"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectBrand" :key="type.brandId">{{ type.brandName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="型号" style="margin-left: 60px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeModelName"
                :filterOption="filterOption"
                v-model="queryParam.model"
              >
                <a-select-option v-for="type in selectModel" :key="type.modelId">{{ type.modelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="9" :sm="24">
            <a-form-item label="建单时间" style="margin-left: 26px">
              <a-range-picker
                style="width: 100%"
                v-model="createTime"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangecreateOrde"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="师傅结算状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.masterSettleStatus" :allowClear="true">
                <a-select-option v-for="type in settlement_status" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="企业结算状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.enterpriseSettleStatus" :allowClear="true">
                <a-select-option v-for="type in settlement_status" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="9" :sm="24">
            <a-form-item label="订单完成时间">
              <a-range-picker
                style="width: 100%"
                v-model="completeTime"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangecompleteOrder"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!--        筛选的条件-->
        <!--        查询和清空按钮-->
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="15"></a-col>
            <a-col :span="8" :style="{ textAlign: 'right' }">
              <a-button type="primary" style="" htmlType="submit" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="exportOrderMasterStatement" @click="exportEnt()"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
        </span>
      </a-form>
    </div>
    <!--   江苏锁安科技有限公司 2020年2月对帐单  表头-->
    <a-row v-if="editList">
      <a-col :span="21">
        <h1 style="text-align: center">{{ editList.subStatementName }}</h1>
        <h4 style="text-align: center">
          <span style="font-size: 16px; line-height: 30px; margin-right: 10px">账单号：{{ editList.statementNo }}</span>
          <span style="font-size: 16px; line-height: 30px">截止至：{{ editList.closingDate }}</span>
        </h4>
        <h4 style="text-align: center">
          <span style="font-size: 16px; line-height: 30px; margin-right: 10px"
            >师傅负责人：{{ editList.masterPrincipal }}</span
          >
          <span style="font-size: 16px; line-height: 30px; margin-right: 10px"
            >结算方式：{{ editList.settleMethod }}</span
          >
          <span style="font-size: 16px; line-height: 30px">结算周期：{{ editList.settleCycle }}</span>
        </h4>
      </a-col>
    </a-row>
    <a-row v-if="editList">
      <a-col>
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="9">
            <span style="font-size: 16px; margin-right: 10px; line-height: 30px"
              >支付超期：{{ editList.overdueDate }}</span
            >
            <span style="font-size: 16px; line-height: 30px">支付日期：{{ editList.payDate }}</span>
          </a-col>
          <a-col :span="8" style="margin-top: 5px">
            <a-checkbox @change="onChangeSettleComplete"> 不显示已结算订单 </a-checkbox>
            <a-checkbox @change="onChangeDeduction"> 显示扣款订单 </a-checkbox>
            <a-checkbox @change="onChangeLoss"> 显示倒挂订单 </a-checkbox>
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <div style="margin-bottom: 16px"></div>
    <!--        表格内容-->
    <a-table
      v-if="editList"
      size="default"
      ref="table"
      rowKey="orderId"
      :columns="columns"
      :dataSource="editList.orders"
      bordered
      :pagination="false"
      :scroll="{ x: 6200, y: 450 }"
      :rowClassName="setClassName"
    >
      <template slot="money" slot-scope="text, record">
        <span v-if="!editableArray[0]">{{ record.masterSettleAmount }}</span>
        <editable-cell
          v-else
          :editable="editableArray[0]"
          :text="record.masterSettleAmount"
          @finishEdit="finishEdit(0)"
          @change="onCellChange(record.orderId, $event)"
        /> </template
      >>
      <span slot="action" slot-scope="text, record" style="white-space: nowrap">
        <a v-if="select" @click="orderdetailsView(record.orderId)">查看</a>
        <a-divider
          type="vertical"
          v-if="record.settleStatusCode == 0 || (record.settleStatusCode == 1 && singleSettlementEnterpriseStatement)"
        />
        <a
          v-if="record.settleStatusCode == 0 || (record.settleStatusCode == 1 && singleSettlementEnterpriseStatement)"
          @click="billCompleted(record.orderId, 2)"
          >结算完成</a
        >
        <a-divider
          type="vertical"
          v-if="
            (record.settleStatusCode == 2 || record.settleStatusCode == 3) &&
            record.statementStatusCode != 6 &&
            record.statementStatusCode != 7 &&
            singleSettlementEnterpriseStatement
          "
        />
        <a
          v-if="
            (record.settleStatusCode == 2 || record.settleStatusCode == 3) &&
            record.statementStatusCode != 6 &&
            record.statementStatusCode != 7 &&
            singleSettlementEnterpriseStatement
          "
          @click="refundButton(record.orderId, 2)"
          >退款</a
        >
        <a-divider type="vertical" v-if="removeMasterSingle" />
        <a v-if="removeMasterSingle" @click="remove(record)">移除</a>
        <a-divider type="vertical" v-if="remarkMasterSingle" />
        <a v-if="remarkMasterSingle" @click="remarkList(record)">备注</a>
      </span>
      <span slot="remark" slot-scope="text, record">
        <span v-if="record.remark">
          <span v-for="tab in record.remark.split('/$/')">
            <span>
              {{ tab }}
            </span>
            <br />
          </span>
        </span>
      </span>
      <!--enterpriseSettleAmount-->
      <span slot="enterpriseSettleAmount" slot-scope="text, record">
        <span v-if="record.enterpriseStatementFlag == 0">
          <a style="color: red">{{ record.enterpriseSettleAmount }}</a>
        </span>
        <span v-else>
          <a>{{ record.enterpriseSettleAmount }}</a>
        </span>
      </span>
    </a-table>
    <!--    最后字段第一行-->
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="19" style="text-align: center">
            <span style="font-size: 14px; font-weight: 700" v-if="viewPriceMasterStatement"
              >【企业】订单总金额：{{ editList.enterpriseTotalAmount }}元 结算总金额：{{
                editList.enterpriseSettleAmount
              }}元
            </span>
            <span style="font-size: 14px; font-weight: 700"
              >【师傅】订单总金额：{{ editList.masterTotalAmount }}元 结算总金额：{{ editList.masterSettleAmount }}元
            </span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!--    最后字段第二行-->
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="19" style="text-align: center">
            <span style="font-size: 14px; font-weight: 700; text-align: center"
              >成本：{{ editList.cost }}元 毛利：{{ editList.grossProfit }}元 结算扣款：{{ editList.deduction }}元
              已退款金额：{{ editList.alreadyRefundAmount }}元 订单总计：{{ editList.orderNum }}单
            </span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="19" style="text-align: center">
            <span style="font-size: 14px; font-weight: 700; text-align: center"
              >结算金额：{{ editList.masterTotalAmount }}元 已结算金额：{{ editList.alreadySettleAmount }}元
              实际需结算：{{ editList.needSettleAmount }}元 已退款金额：{{ editList.alreadyRefundAmount }}元
              订单总计：{{ editList.orderNum }}单
            </span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!--    最后的按钮-->
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="3"> </a-col>
          <a-col :span="21" style="text-align: center; margin: 20px 0">
            <a-button
              type="primary"
              style="margin-left: 8px"
              @click="billCompleted(editList.statementId, 1)"
              v-if="
                (singleSettlementEnterpriseStatement && editList.settleStatusCode == 0) ||
                editList.settleStatusCode == 1
              "
              >结算完成</a-button
            >
            <a-button
              type="primary"
              style="margin-left: 8px"
              v-if="
                singleSettlementEnterpriseStatement &&
                (editList.settleStatusCode == 2 || editList.settleStatusCode == 3) &&
                editList.statementStatusCode != 6 &&
                editList.statementStatusCode != 7
              "
              @click="refundButton(editList.subStatementId, 1)"
              >退款</a-button
            >
            <a-button
              type="primary"
              style="margin-left: 8px"
              v-if="modifyMasterSingle && editList.statementStatus != 7"
              @click="eaitStatement(0)"
              >修改对帐单</a-button
            >
            <!--              <a-button type="primary" style="margin-left: 18px;width: 120px;" @click="submitStatement(editList.statementId)">提交对帐单</a-button>-->
            <a-button style="margin-left: 8px" @click="goone()">返回</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!--    结算完成的弹框-->
    <a-modal
      title="结算"
      style="top: 20px"
      :width="800"
      v-model="Settlementible"
      :confirmLoading="confirmLoading"
      @ok="EnterpriseOk"
      @cancel="handleCancel"
    >
      <a-form :form="formSettlement">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需支付">
          <a-input v-decorator="['needpayAmount']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际支付">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请填写实际支付金额!' }],
              },
            ]"
            :max="this.formSettlement.getFieldValue('needpayAmount')"
            @change="amountModify"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未支付">
          <a-input v-decorator="['Unpaid']" disabled="disabled" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }],
              },
            ]"
          >
            <a-select-option v-for="type in pay_method" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input
            type="textarea"
            v-decorator="[
              'remark',
              {
                rules: [
                  {
                    required: this.formSettlement.getFieldValue('Unpaid') > 0 ? true : false,
                    message: '请输入备注信息!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--    移除的弹框提醒-->
    <!--    移除对账单确定按钮-->
    <a-modal
      title="移除"
      style="top: 20px"
      :width="800"
      v-model="removeible"
      :confirmLoading="confirmLoading"
      @ok="confirmOk"
      @cancel="confirmCancel"
    >
      <p>确定移除该条对账单吗？</p>
    </a-modal>
    <!--    // 退款-->
    <a-modal
      title="退款"
      style="top: 20px"
      :width="800"
      v-model="refundible"
      :confirmLoading="confirmLoading"
      @ok="refundOk"
      @cancel="refundCancel"
    >
      <a-form :form="refundform">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际收款">
          <a-input v-decorator="['realReceipts']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请输入退款金额!' }],
              },
            ]"
            :max="this.refundform.getFieldValue('realReceipts')"
            @change="amountModify"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="余额">
          <a-input v-decorator="['balance']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }],
              },
            ]"
          >
            <a-select-option v-for="type in pay_method" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input type="textarea" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
      <a-form :form="form">
        <div>
          <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
            <div v-for="type in remarkrows" :key="type.remarkId">
              <span style="margin: 0 30px"> {{ type.remark }}</span>
              <span style="margin: 0 10px"> {{ type.createBy }}</span>
              <span> {{ type.createTime }}</span>
            </div>
          </a-form-item>
        </div>
        <a-form-item style="display: none">
          <a-input v-decorator="['enterpriseId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
          <a-input v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 使用弹框组件-->
    <modify-default-template-model ref="modify"></modify-default-template-model>
    <edit-order-model
      v-if="$store.state.user_type == 1"
      ref="editorder"
      @ok="$refs.table.refresh(true)"
    ></edit-order-model>
    <edit-order-model1 v-else ref="editorder" @ok="$refs.table.refresh(true)"></edit-order-model1>
  </a-modal>
</template>
<script>
// 组件
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}

        </div>
      </div>
    `,
  props: {
    text: String,
    editable: Boolean,
  },
  data() {
    return {
      value: this.text,
      editable: this.editable,
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
      this.$emit('finishEdit')
    },
    edit() {
      this.editable = true
    },
  },
}
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import modifyDefaultTemplateModel from '../modules/modifyDefaultTemplateModel.vue'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
  getfinddictAll,
} from '@/api/order/orderList'
import { STable } from '@/components'
import {
  getSeparateList,
  getupdateExpectDate,
  getQueryNeedPay,
  getEnterpriseSettleList,
  removeList,
  getStatementRreceiver,
  getTemplate,
  getAlreadyPay,
  getRefundList,
  getupdateSettleAmount,
  getexportList,
} from '@/api/finance/masterSingle'
import { getEditList } from '@/api/finance/MasterStatementList'
import { getremarkList, saveremarkList } from '@/api/finance/enterpriseBill'
import EnterpriseModal from '../modules/EnterpriseModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../../utils/dict'
const options = [
  { label: '不显示已结算订单', value: '不显示已结算订单' },
  { label: '只显示扣款订单', value: '只显示扣款订单' },
  { label: '只显示倒挂订单', value: '只显示倒挂订单' },
]
export default {
  name: 'customerSingle',
  components: {
    STable,
    // 注册弹框组件
    EnterpriseModal,
    EditableCell,
    modifyDefaultTemplateModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      masterSingleible: false,
      refundible: false,
      realReceipts: '',
      refund: '',
      refundid: '',
      amountUpdateFlag: '',
      // 提交对账单
      subStatementsId: [],
      // 移除按钮
      removeible: false,
      removeLoading: false,
      orderId: '',
      // 备注
      remark: '',
      // 保存账单的id 2
      settleTargetId: '',
      // 保存子账单的id的 1
      statementId: '',
      // 支付方式
      payMethod: '',
      // <!--    操作栏结算完成-->
      needpayAmount: '',
      actualpayAmount: '',
      // <!--    结算完成的弹框-->
      Settlementible: false,

      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      //分单提交 需要的值
      separateMethod: '',
      // 编辑带过来的数据
      editList: '',
      loading: false,
      form: this.$form.createForm(this),
      refundform: this.$form.createForm(this),
      formSettlement: this.$form.createForm(this),
      editableArray: new Array(100).fill(false),
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 80,
          key: '1',
        },
        {
          title: '操作栏',
          width: 220,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          key: '2',
        },
        {
          title: '状态栏',
          dataIndex: 'subOrParent',
          align: 'center',
          width: 170,
          key: '3',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 170,
          key: '4',
        },
        {
          title: '安装数量',
          dataIndex: 'installNum',
          align: 'center',
          width: 170,
          key: '5',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          width: 170,
          key: '6',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          width: 170,
          key: '7',
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          align: 'center',
          width: 170,
          key: '8',
        },
        {
          title: '型号',
          dataIndex: 'model',
          align: 'center',
          width: 170,
          key: '9',
        },
        {
          title: '结算总金额',
          dataIndex: 'masterSettleAmount',
          align: 'center',
          scopedSlots: { customRender: 'money' },
          width: 170,
          key: '10',
        },
        {
          title: '实际结算差额',
          dataIndex: 'trueSettleAmountDiffer',
          align: 'center',
          width: 170,
          key: '11',
        },
        {
          title: '订单总金额',
          dataIndex: 'masterTotalAmount',
          align: 'center',
          width: 170,
          key: '12',
        },
        {
          title: '基础费用',
          dataIndex: 'baseAmount',
          align: 'center',
          width: 170,
          key: '13',
        },
        {
          title: '额外费用',
          dataIndex: 'otherAmount',
          align: 'center',
          width: 170,
          key: '14',
        },
        {
          title: '已结算金额',
          dataIndex: 'alreadySettleAmount',
          align: 'center',
          width: 170,
          key: '15',
        },
        {
          title: '实际需结算',
          dataIndex: 'needSettleAmount',
          align: 'center',
          width: 170,
          key: '16',
        },
        {
          title: '已退款金额',
          dataIndex: 'alreadyRefundAmount',
          align: 'center',
          width: 170,
          key: '17',
        },
        {
          title: '成本',
          dataIndex: 'cost',
          align: 'center',
          width: 170,
          key: '18',
        },
        {
          title: '师傅结算状态',
          dataIndex: 'masterSettleStatus',
          align: 'center',
          width: 170,
          key: '19',
        },
        {
          title: '企业结算状态',
          dataIndex: 'enterpriseSettleStatus',
          className: this.viewPriceMasterStatement ? '' : 'notshow',
          align: 'center',
          width: 170,
          key: '20',
        },
        {
          title: '企业结算总金额',
          dataIndex: 'enterpriseSettleAmount',
          className: this.viewPriceMasterStatement ? '' : 'notshow',
          scopedSlots: { customRender: 'enterpriseSettleAmount' },
          align: 'center',
          width: 170,
          key: '21',
        },
        {
          title: '企业订单总金额',
          dataIndex: 'enterpriseTotalAmount',
          className: this.viewPriceMasterStatement ? '' : 'notshow',
          align: 'center',
          width: 170,
          key: '22',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center',
          width: 170,
          key: '23',
        },
        {
          title: '客户姓名',
          dataIndex: 'customerName',
          align: 'center',
          width: 170,
          key: '24',
        },
        {
          title: '联系方式',
          dataIndex: 'customerMobile',
          align: 'center',
          width: 170,
          key: '25',
        },
        {
          title: '省',
          dataIndex: 'province',
          align: 'center',
          width: 170,
          key: '26',
        },
        {
          title: '市',
          dataIndex: 'city',
          align: 'center',
          width: 170,
          key: '27',
        },
        {
          title: '区',
          dataIndex: 'area',
          align: 'center',
          width: 170,
          key: '28',
        },
        {
          title: '详细地址',
          dataIndex: 'address',
          width: 200,
          key: '29',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
          width: 170,
          key: '30',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
          width: 170,
          key: '31',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 170,
          key: '32',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderCompleteTime',
          align: 'center',
          width: 170,
          key: '33',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          key: '34',
        },
      ],
      // post的返回值
      reslist: '',
      options,
      value1: 'installType',
      value2: '不显示已结算订单',
      // 字典为pay_method
      installTypes: [],
      order_substate: [],
      form2: this.$form.createForm(this),
      // 省
      selectAllProvince: [],
      settlement_status: [],
      // 市
      selectCityName: [],
      selectBrand: [],
      selectModel: [],
      // 区
      selectAreaName: [],
      pay_method: [],
      // 字典为分单方式
      plainOptions: [],
      removeMasterSingle: checkPermission('removeMasterSingle'),
      exportOrderMasterStatement: checkPermission('exportOrderMasterStatement'),
      remarkMasterSingle: checkPermission('remarkMasterSingle'),
      singleSettlementEnterpriseStatement: checkPermission('singleSettlementEnterpriseStatement'),
      // 查看企业金额
      viewPriceMasterStatement: checkPermission('viewPriceMasterStatement'),
      modifyMasterSingle: checkPermission('modifyMasterSingle'),
      select: checkPermission('order:list:select'),
      List: [],
      masterstatementId: '',
      settlementtype: '',
      refundtype: '',
      remarkrows: '',
      remarkible: false,
      completeTime: '',
      createTime: '',
      editable: false,
      recordorderId: '',
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {},
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    onChangeSettleComplete(e) {
      if (e.target.checked) {
        this.queryParam.notShowSettleComplete = 1
      } else {
        this.queryParam.notShowSettleComplete = ''
      }
      this.query()
    },
    onChangeDeduction(e) {
      if (e.target.checked) {
        this.queryParam.showDeduction = 1
      } else {
        this.queryParam.showDeduction = ''
      }
      this.query()
    },
    onChangeLoss(e) {
      if (e.target.checked) {
        this.queryParam.showLoss = 1
      } else {
        this.queryParam.showLoss = ''
      }
      this.query()
    },
    async showcreated() {
      this.empty()
      let dictTypes = ['install_type', 'order_substate', 'settlement_status', 'pay_method']
      getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
        this.installTypes = res.install_type
        this.order_substate = res.order_substate
        this.settlement_status = res.settlement_status
        this.pay_method = res.pay_method
      })
      // 字典为分单方式
      this.plainOptions = []
      this.restaurantOperTypeMap = await getDictMap('seperate_order_method')
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.plainOptions.push({ value: key, label: value })
      })
      this.selectBrand = []
      await getSelectBrand().then((res) => {
        if (res.code === 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectModel = []
      await getSelectModel().then((res) => {
        if (res.code === 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      await getselectAllProvince().then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    empty() {
      this.queryParam = {}
      this.createTime = ''
      this.completeTime = ''
      this.form2.resetFields()
    },
    moment,
    setClassName(record) {
      // console.log(record)
      if (record.temporarilySettle == 1) {
        return 'clickRowStyle'
      } else if (record.isLossOrder == 1) {
        return 'clickRowStyleOrange'
      }
    },
    exportEnt() {
      this.queryParam.statementId = this.masterstatementId
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/masterController/detailExport?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      console.log(str)
      window.open(str)

      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      // getexportList(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_师傅账单'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    //     this.masterstatementId=this.$route.params.statementId
    showmasterSingle(id) {
      //console.log(this.viewPriceMasterStatement)
      this.showcreated()
      ;(this.editableArray = new Array(100).fill(false)), (this.masterSingleible = true)
      this.masterstatementId = id
      getEditList({ statementId: this.masterstatementId }).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    query() {
      this.queryParam.statementId = this.masterstatementId
      // this.queryParam.orderType=this.f
      getEditList(this.queryParam).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    eaitStatement(index) {
      this.editableArray[index] = true
      this.editableArray = _.cloneDeep(this.editableArray)
    },
    finishEdit(index) {
      this.editableArray[index] = false
      this.editableArray = _.cloneDeep(this.editableArray)
    },
    onCellChange(key, value) {
      getupdateSettleAmount({ subStatementId: this.masterstatementId, orderId: key, newAmount: value }).then((res) => {
        if (res.code === 0) {
          this.refreshEditList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkList(record) {
      this.form.resetFields()
      this.remarkrows = []
      this.recordorderId = ''
      this.remarkible = true
      this.recordorderId = record.orderId
      getremarkList({ billRemarkType: 2, orderId: record.orderId }).then((res) => {
        if (res.code === 0) {
          this.refreshEditList()
          this.remarkrows = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.form.validateFields((err, values) => {
        values.billRemarkType = 2
        values.orderId = this.recordorderId
        if (!err) {
          saveremarkList(values).then((res) => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    amountModify(e) {
      let realReceipts = this.refundform.getFieldValue('realReceipts')
      this.refundform.setFieldsValue({
        balance: realReceipts - 0 - e,
      })
      let needpayAmount = this.formSettlement.getFieldValue('needpayAmount')
      this.formSettlement.setFieldsValue({
        Unpaid: needpayAmount - 0 - e,
      })
    },
    orderdetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(orderId, '', 0)
      })
    },

    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },

    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    installChange9(e) {
      this.queryParam.orderType = e
    },
    async installChange(e) {
      this.form2.setFieldsValue({
        orderType9: '',
      })
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangecreateOrde(date, dateString) {
      this.queryParam.createOrderTimeBegin = dateString[0]
      this.queryParam.createOrderTimeEnd = dateString[1]
    },
    onChangecompleteOrder(date, dateString) {
      this.queryParam.orderCompleteTimeBegin = dateString[0]
      this.queryParam.orderCompleteTimeEnd = dateString[1]
    },

    // 退款
    refundButton(id, type) {
      this.refundtype = type
      this.refundform.resetFields()
      this.refundible = true
      if (type == 1) {
        this.refundid = this.masterstatementId
        getAlreadyPay({ statementType: type, statementId: this.refundid }).then((res) => {
          if (res.code === 0) {
            setTimeout(() => {
              this.refundform.setFieldsValue({
                realReceipts: res.data,
              })
            }, 100)
            // this.realReceipts =res.data
            // console.log(res)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.refundid = id
        getAlreadyPay({ statementType: type, statementId: id }).then((res) => {
          if (res.code === 0) {
            setTimeout(() => {
              this.refundform.setFieldsValue({
                realReceipts: res.data,
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 确定时调用的方法
    refundOk() {
      console.log(this.payMethod, this.refundid)
      this.refundform.validateFields((err, values) => {
        values.refundTargetId = this.refundid
        values.refundTargetType = this.refundtype
        console.log(values)
        if (!err) {
          this.refundible = false
          this.confirmLoading = false
          getRefundList(values).then((res) => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
      this.realReceipts = ''
      this.payMethod = ''
      this.remark = ''
    },
    // 取消时调用的方法
    refundCancel() {
      this.refundible = false
      // this.$router.push({name:'enterpriseStatement'})
    },
    // 修改默认模板
    modifyDefaultTemplate() {
      getTemplate({ enterpriseId: this.editList.enterpriseId }).then((res) => {
        if (res.code === 0) {
          console.log(res.data)
          this.$refs.modify.showmodify(res.data)
          // this.$router.push({name:'modifyDefaultTemplate',params:{
          //     reslist:res.data}})
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goone() {
      // this .$router.go(-1)
      this.masterSingleible = false
    },

    billCompleted(id, type) {
      this.formSettlement.resetFields()
      this.settlementtype = type
      this.Settlementible = true

      if (type == 1) {
        this.settleTargetId = this.masterstatementId
        getQueryNeedPay({ statementType: type, statementId: this.settleTargetId }).then((res) => {
          if (res.code === 0) {
            setTimeout(() => {
              this.formSettlement.setFieldsValue({
                needpayAmount: res.data,
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.settleTargetId = id
        getQueryNeedPay({ statementType: type, statementId: this.settleTargetId }).then((res) => {
          if (res.code === 0) {
            setTimeout(() => {
              this.formSettlement.setFieldsValue({
                needpayAmount: res.data,
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 确定时调用的方法
    EnterpriseOk() {
      this.formSettlement.validateFields((err, values) => {
        values.settleTargetType = this.settlementtype
        values.settleTargetId = this.settleTargetId
        console.log(values)
        if (!err) {
          this.Settlementible = false
          this.confirmLoading = false
          getEnterpriseSettleList(values).then((res) => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
      this.actualpayAmount = ''
      this.payMethod = ''
      this.remark = ''
    },
    // 取消时调用的方法
    handleCancel() {
      this.Enterprisevisible = false
      // this.$router.push({name:'enterpriseStatement'})
    },
    // 第一个单选框的change事件
    onChangeRadio1(e) {
      // console.log(e.target.value)
      this.separateMethod = e.target.value
      // console.log( this.separateMethod)
    },
    // 分单 提交
    reinsurancePolicy() {
      getSeparateList({ separateMethod: this.separateMethod, statementId: this.editList.majorStatementId }).then(
        (res) => {
          if (res.code === 0) {
            this.refreshEditList()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 移除
    remove(record) {
      this.statementIds = ''
      this.removeible = true
      this.statementIds = record.orderId
      console.log(record)
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
    },
    refreshEditList() {
      this.$message.success('操作成功')
      this.$emit('ok')
      getEditList({ statementId: this.editList.statementId }).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msgetEditListg)
        }
      })
    },
    // 移除确定时调用的方法
    async confirmOk() {
      this.removeible = false
      this.removeLoading = false
      await removeList({ orderId: this.statementIds }).then((res) => {
        if (res.code === 0) {
          this.refreshEditList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    // 点按钮生成对账单
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    },
  },
  watch: {},
}
</script>
<style scoped>
/deep/ .clickRowStyle {
  background: #d3d3d3;
}
/deep/ .clickRowStyleOrange {
  background: #ffbb77;
}
/deep/ .classYellow {
  background-color: #ffe168;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
/deep/ .notshow {
  display: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px;
}
</style>